import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const weekViewDatePickerBaseStyle = css`
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing(3)};
  width: fit-content;

  .week-view-heading {
    text-align: center;
    margin-bottom: ${theme.spacing(2)};
  }

  .week-day-bar {
    align-items: center;
    display: flex;
    gap: ${theme.spacing(1)};

    .week-day-list {
      display: flex;
      flex-wrap: wrap;
      gap: ${theme.spacing(1)};
      justify-content: center;

      .week-day-item {
        align-items: center;
        border-radius: ${theme.borderRadius.medium};
        cursor: pointer;
        display: flex;
        flex-direction: column;
        min-width: ${theme.spacing(6)};
        overflow: hidden;
        padding: ${theme.spacing(1)};
        transition: background-color 200ms ease-in-out, color 200ms ease-in-out;
        width: ${theme.spacing(6)};

        &:focus,
        &:hover {
          background: ${theme.colors.neutral5};
          color: ${theme.colors.neutral80};
          outline: none;
        }

        &.selected,
        &[aria-selected='true'] {
          background-color: ${theme.colors.text.interactive};
          color: ${theme.colors.white};
        }

        &.disabled {
          color: ${theme.colors.text.disabled};
          pointer-events: none;
        }

        &.pre-selected {
          box-shadow: 0 0 0 1px ${theme.colors.text.disabled};
        }

        span {
          color: inherit;
        }
      }
    }
  }

  .time-bar {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: ${theme.spacing(4)};

    > div {
      max-width: ${theme.spacing(18)};
    }

    @media screen and (min-width: ${theme.spacing(60)}) {
      flex-direction: row;
      gap: ${theme.spacing(3)};

      > p {
        margin-top: ${theme.spacing(1)};
      }
    }
  }

  .action-bar {
    align-items: center;
    display: flex;
    gap: ${theme.spacing(2)};
    justify-content: flex-end;
    margin-top: ${theme.spacing(5)};

    button {
      width: auto;
    }

    p {
      color: ${theme.colors.text.subdued};
      margin: 0;
    }
  }
`;

export const weekViewDatePickerThemeStyles: Record<'dark' | 'light', string> = {
  dark: css`
    background: ${theme.colors.neutral90};
    color: ${theme.colors.white};
  `,
  light: css`
    background: ${theme.colors.white};
    color: ${theme.colors.neutral90};
  `,
};
